import {AppConfig} from "../app.config";
import {Injectable} from "@angular/core";
import {instanceToPlain, plainToInstance} from "class-transformer";
import {ClassConstructor} from "class-transformer/types/interfaces";

@Injectable({
  providedIn: 'root'
})
export class TableStateService {
  constructor(private appConfig: AppConfig) {
  }

  getOrDefault<T>(key: string, cls: ClassConstructor<T>, defaultValue: T) {
    let storage = this.appConfig.getStorage();

    let item = storage.getItem(key);
    if(item){
      return plainToInstance(cls, JSON.parse(item))
    }
    return defaultValue;
  }

  ensure<T>(key: string, t: T) {
    let json = instanceToPlain(t);
    this.appConfig.getStorage().setItem(key, JSON.stringify(json));
  }
}
